import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { LookInside } from './components/LookInside';
import { VolumeCarousel } from './components/VolumeCarousel/VolumeCarousel';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { PurchaseNotifications } from './components/PurchaseNotifications';
import { shortTestimonials, moreTestimonials } from './data/testimonials';
type AppProps = {
  carouselAutoplay?: boolean;
};
export function App({
  carouselAutoplay = true
}: AppProps) {
  return <div className="min-h-screen w-full bg-plum text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="3rbrbcsn2y3gv">
      <MetaPixel data-id="element-1" data-mp="4wvvprmowg9" />
      <main data-id="element-2" data-mp="5gez9t0lqvv">
        <Hero data-id="element-3" data-mp="56m9egl55mh" />
        <VolumeCarousel autoplay={carouselAutoplay} data-id="element-4" data-mp="7suzhf7pr6a" />
        <SocialProofBar data-id="element-5" data-mp="2zm4xqkjlzd1t" />
        <PainGrid data-id="element-6" data-mp="2zmwguvw0rib7" />
        <ProductReveal data-id="element-7" data-mp="2zng2onosiqui" />
        <Tomes data-id="element-8" data-mp="33m5b01uz1i7a" />
        <Bonuses data-id="element-9" data-mp="33lx18iu5at0b" />
        <LookInside data-id="element-10" data-mp="33ngiabnml835" />
        <ValueStack data-id="element-11" data-mp="33oriy2lrxzq1" />
        <Urgency data-id="element-12" data-mp="38lrqkhy9vaj9" />
        <Pricing data-id="element-13" data-mp="38l8gtoirzsgb" />
        {/* Review blocks render only once there are real buyer reviews (see data/testimonials.ts). */}
        {shortTestimonials.length > 0 && <Testimonials testimonials={shortTestimonials} background="white" data-id="element-14" data-mp="3dii530ufhy2k" />}
        <Guarantee data-id="element-15" data-mp="nxn6nvnsp9oy" />
        <Faq data-id="element-16" data-mp="sunas11342df" />
        {moreTestimonials.length > 0 && <Testimonials testimonials={moreTestimonials} title="More rooms, more weeks" background="blush" data-id="element-17" data-mp="st2iyj65mxj9" />}
        <CostOfInaction data-id="element-18" data-mp="3udazkg91d18e" />
        <Close data-id="element-19" data-mp="3ubzu8bzxzlf6" />
      </main>
      <Footer data-id="element-20" data-mp="3uevq7us8c00z" />
      <PurchaseNotifications data-id="element-21" data-mp="d4nwrk0ubq3z" />
    </div>;
}